module.exports = __webpack_public_path__ + "static/media/technical_parts1.1be4949f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/technicalProducts/technical_parts1.jpg
// module id = 217
// module chunks = 0